"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _logService = require("../tools/service/log/logService");
var _Tabs = require("./Tabs.utils");
var _Tabs2 = require("./Tabs.types");
var _context = require("./context");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
} /* eslint-disable @typescript-eslint/no-empty-function */
var styles = {
  "list": "ayT8JN",
  "medium": "pTD8kS",
  "large": "Av2gfM"
};
var getSizeClassName = function getSizeClassName(size) {
  switch (size) {
    case _Tabs2.TabsSize.LARGE:
      return styles.large;
    case _Tabs2.TabsSize.MEDIUM:
    default:
      return styles.medium;
  }
};
var Tabs = function Tabs(_ref) {
  var children = _ref.children,
    onChange = _ref.onChange,
    activeTabFromOutsideId = _ref.activeTab,
    size = _ref.size;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    activeTab = _useState2[0],
    setActiveTab = _useState2[1];
  var handleSetActiveTab = function handleSetActiveTab(tabId) {
    setActiveTab(tabId);
    onChange(tabId);
  };
  (0, _react.useEffect)(function () {
    if (_react.Children.count(children) === 0) {
      (0, _logService.logSpecificErrorMessage)('TABS', 'Provide at least one Tab as child');
      return;
    }
    if (activeTabFromOutsideId) {
      handleSetActiveTab(activeTabFromOutsideId);
    } else {
      var initialActiveTabId = (0, _Tabs.findInitialActiveTabId)(children);
      handleSetActiveTab(initialActiveTabId);
    }
  }, [activeTabFromOutsideId]);
  return /*#__PURE__*/_react["default"].createElement(_context.TabsContext.Provider, {
    value: {
      activeTab: activeTab,
      setActiveTab: handleSetActiveTab
    }
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    role: "tablist",
    className: (0, _clsx["default"])(styles.list, getSizeClassName(size))
  }, children));
};
Tabs.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes["default"].node,
  onChange: _propTypes["default"].func,
  activeTab: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(_Tabs2.TabsSize))
} : {};
Tabs.defaultProps = {
  onChange: function onChange() {},
  size: _Tabs2.TabsSize.MEDIUM
};
var _default = exports["default"] = Tabs;